<template lang="pug">
  section
    b-container
      h1.mt-0(v-if="this.payout") Payout an artist
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'PayoutsEligible'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to All
      h4 Payout
      .row
        .col-md-6
          content-loader(:height="7", v-if="alert.loading")
          b-card(v-else-if="payout")
            .container
              .row
                .col-12
                  p Payment
                  .row
                    .col-6
                      span.small Artist
                      p.mb-1 {{ payout.artist_name }}
                    .col-6
                      span.small {{ `${payout.completed ? 'Paid to ' : 'Due to'} artist` }}
                      b.d-block.mb-1.text-bold {{ formatRandsCents(payout.amount) }}
                  hr
                  .row(v-if="payout.bank_account")
                    .col-4
                      span.small Bank
                      p.mb-1 {{ payout.bank_account.bank_name }}
                    .col-4
                      span.small Type
                      p.mb-1 {{ payout.bank_account.type }}
                    .col-4
                      span.small Account
                      p.mb-1 {{ payout.bank_account.account_number }}
        .col-md-6
          content-loader(:height="7", v-if="alert.loading")
          b-card(v-else-if="!payout.bank_account")
            .row
              .col-12
                h4.m-0.mt-1 No account
                p This artist has not yet completed their bank details
          b-card(v-else-if="payout && !payout.completed")
            .row
              .col-6
                h4.m-0.mt-1 PAY ARTIST
              .col-6.text-right
                button-load(:flag="alert.busy", label="COMPLETE PAYOUT", classes="btn-light", v-on:clicked="submitThisPayout")
          //b-card(v-else-if="payout && payout.completed && !payout.pop")
            p Add Proof of Payment
            b-form.mb-0(@submit.prevent="uploadPop")
              .row
                .col-8
                  b-form-group
                    b-form-file(v-model="popFile", accept=".pdf", required, :state="Boolean(popFile)", placeholder="Upload Proof Of Payment", drop-placeholder="Drop file here...")
                .col-4
                  div.text-right
                    button-load(type="submit", :flag="alert.busy", label="Submit", classes="btn-theme")
          //b-card(v-else="")
            h4.mt-2
              font-awesome-icon(icon="check")
              span.ml-2 Payout complete

      h4 Items
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="payout && payout.customer_order_lines")
        b-table(:items="payout.customer_order_lines", :fields="fields", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
          template(v-slot:cell(compTitle)="row")
              p.m-0.d-inline {{ `${row.item.art_name} ${row.item.quantity > 1 ? ` x ${row.item.quantity}` : ''}` }}
              b-badge.ml-2(variant="dark") {{ row.item.order_type }}
          //- template(v-slot:cell(compCommission)="row") {{ formatRandsCents(row.item.commission) }}
          template(v-slot:cell(compNet)="row") {{ formatRandsCents(row.item.to_artist) }}
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';

export default {
  name: 'Payout',
  mixins: [standardMix],
  data() {
    return {
      payout: null,
      popFile: null,
      fields: [
        { key: 'compTitle', label: 'Piece' },
        // { key: 'compType', label: 'Type' },
        // { key: 'compQuantity', label: 'Quantity' },
        // { key: 'compTotal', label: 'Line Total' },
        // { key: 'compCommission', label: 'Commission' },
        { key: 'compNet', label: 'To Artist' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
  },
  methods: {
    async submitThisPayout() {
      try {
        this.busy();
        const { id } = await apiService.addPayout(this.payout);
        this.payout.id = id;
        this.payout.completed = true;
        this.success('Payout added');
      } catch (error) {
        this.error('Could not complete this payout');
      }
    },
    // async uploadPop() {
    //   try {
    //     this.busy();
    //     await apiService.updatePayoutPop(this.popFile, this.payout.id);
    //     this.payout.pop = true;
    //     this.success('Payout complete!');
    //   } catch (error) {
    //     this.error('Could not upload POP');
    //   }
    // },
  },
  async created() {
    if (this.$route.params.payoutId) {
      try {
        this.loading();
        this.payout = await apiService.getPayoutEligible(this.$route.params.payoutId);
        this.clear();
      } catch (error) {
        router.push({ name: 'PayoutsEligible' });
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PayoutEligible.vue